import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import { MultiSelectFilter, SelectTypes } from 'common/components/core/select';
import { translate } from 'react-i18next';
import compose from 'recompose/compose';

import theme from './SlotFilter.scss';

class SlotFilter extends Component {
    constructor(props) {
        super(props);
        const { t } = props;
        this.Days = [
            'SUNDAY',
            'MONDAY',
            'TUESDAY',
            'WEDNESDAY',
            'THURSDAY',
            'FRIDAY',
            'SATURDAY'
        ].map(day => ({ label: t(`days.${day}`), value: day }));
    }

    onDayOptionClick = ({ values, allowEmptyOrNull }) => {
        const { onChange } = this.props;
        const idList = values.map(value => value.value);
        // on clear selection
        if (!idList.length && !allowEmptyOrNull) {
            onChange();
            return;
        }
        onChange({ values: idList, allowEmptyOrNull });
    };

    render() {
        const { theme, className, value, ...rest } = this.props;

        return (
            <MultiSelectFilter
                {...rest}
                theme={theme}
                className={className}
                selectType={SelectTypes.Outline}
                options={this.Days}
                allowEmptyOrNull={value?.allowEmptyOrNull || false}
                value={value?.values || []}
                onChange={this.onDayOptionClick}
            />
        );
    }
}

export default compose(themr('SlotFilter', theme), translate())(SlotFilter);
